<template>
  <div class="view contentBody">
    <div class="content">
      <div class="content-tab-box">
        <span :class="meaulistTab.firstTab==item?'content-tab-box-active':''" @click="tabCurrentFn(item)"
              v-for="(item,index) in meaulistTab.tab" :key="item">{{index}}</span>
      </div>
      <div v-for="item in meaulistTab.tab" :key="item">
        <component v-bind:is="item" v-if="meaulistTab.firstTab==item"></component>
      </div>
    </div>
  </div>
</template>
<script>
import goodsCategories from "./goodsCategories.vue";
import goodsList from "./goodsList.vue";
import personalGoodsList from "./personalGoodsList.vue";
import goodsSpecifications from "./goodsSpecifications.vue";
import customSpecifications from "./customSpecifications.vue";
let tabBox = {
  '商品列表': {property: 'goodsList'},
  '商品分类': {property: 'goodsCategories'},
  '商品规格': {property: 'goodsSpecifications'},
  '定制规格': {property: 'customSpecifications'}
}

export default {
  name: "goods",
  components: {
    goodsCategories,
    goodsList,
    personalGoodsList,
    goodsSpecifications,
    customSpecifications
  },
  data() {
    return {
      meaulistTab: this.meaulist.meaulistGet(this, tabBox),
      activeName:''
    };
  },
  created() {
    this.inittab();
  },
  methods: {
    inittab() {
      this.activeName =
        this.$route.query.tab !== undefined
          ? this.$route.query.tab
          : "goodsList";
    },
    tabCurrentFn(index){
      this.meaulistTab.firstTab = index
    }
  }
};
</script>
